module.exports = __webpack_public_path__ + "static/media/iguazu-falls-19.afccb4d9.jpg";